import type { Pinia } from 'pinia'
import { setActivePinia } from 'pinia'
import { useProjectStore } from '../store/useProjectStore'

let initPromise: Promise<ReturnType<typeof useProjectStore>> | null = null

export function initProjectOnce(pinia: Pinia) {
    if (initPromise) return initPromise
    setActivePinia(pinia)
    initPromise = (async () => {
        const project = useProjectStore()
        await project.ensureProject()
        return project
    })()
    return initPromise
}

export async function initProject(pinia: Pinia) {
    setActivePinia(pinia) // wichtig außerhalb von Vue setup()
    const project = useProjectStore()
    await project.ensureProject()
    return project
}
